module.exports = __webpack_public_path__ + "static/008_Room-1b38bed764b000c0717ef3b7848e6e5c.jpg";